import {AttachmentModel} from '../../../libs/shared/core/src/models/api/attachmentModel';
import {CommentModel} from '../../../src/models/api/commentModel';
import {EmojiMap} from '../../../src/services/emojis/emojis';
import {isValidEmoji, isValidShortcode} from '../emoji/emojiTextHelpers';

export function isCommentOnlyAnEmoji(
  comment: CommentModel | null,
  isReply: boolean,
  attachments: ReadonlyArray<AttachmentModel>,
  emojiValidationMap: EmojiMap,
): boolean {
  if (!comment) {
    return false;
  }
  return (
    isCommentTextASingleEmoji(comment, emojiValidationMap) &&
    !isReply &&
    !comment.annotationUid &&
    attachments.length === 0
  );
}

function isCommentTextASingleEmoji(comment: CommentModel, emojiValidationMap: EmojiMap): boolean {
  return (
    isValidShortcode(comment.text.trim(), emojiValidationMap) ||
    isValidEmoji(comment.text.trim(), emojiValidationMap)
  );
}
